import * as React from 'react';
import { createContext, useContext } from 'react';
import type { IEventField } from './AssistanceViewContext';

// the handlers bundle built in useAssistanceHandlers and extended in index.tsx; only the
// commonly consumed members are typed, the rest is reachable through the index signature
export interface AssistanceHandlers {
    onUpdate: (
        update: IEventField & { action?: string; payload?: Record<string, any>; forceRefetchRecord?: boolean }
    ) => Promise<any>;
    onReselect: (
        reselect: IEventField & { bbox: number[][]; pageIndex: number; isEmailOcr?: boolean }
    ) => Promise<any> | void;
    onReset: () => Promise<any>;
    onFinish: (event?: any) => Promise<any>;
    onFinishAndContinue: (event?: any) => Promise<any>;
    onRetryStep: (event?: any) => Promise<any>;
    onChangeStatus: (status: string, reason?: string) => Promise<any>;
    onReopenForAssistance: (reason?: string) => Promise<any>;
    onSendToLabeling: () => Promise<any>;
    redirectToNextRecord: () => Promise<any>;
    // view state toggles added in index.tsx
    onShowOriginalData: (show: boolean) => void;
    showOriginalData: boolean;
    loading: boolean;
    [key: string]: any;
}

interface AssistanceContextProps {
    // the processing record and the (unsaved) document are backend-shaped and untyped until
    // GraphQL types are generated for them
    record: any;
    setRecord: (record: any) => void;
    mappings?: any;
    refetchMappings?: () => Promise<any>;
    refetchData: () => Promise<any>;
    refetchDataNetworkStatus: number;
    document: any;
    ocr: any;
    emailOcr: any;
    handlers: AssistanceHandlers;
    tabs: Record<string, React.ComponentType<any>>;
    documentConfiguration: any;
    pagination:
        | { nextRecordId?: string; previousRecordId?: string; filteredCount?: number; position?: number }
        | undefined;
    loading: boolean;
    alert: { title?: string; message?: string; button?: React.ReactNode; [key: string]: any } | undefined;
    readOnly?: boolean;
    // state
    isFinished: boolean;
    isAssistanceNeeded: boolean;
}

const AssistanceContext = createContext<AssistanceContextProps>({} as AssistanceContextProps);

export const AssistanceContextProvider = ({
    children,
    ...props
}: AssistanceContextProps & { children: React.ReactNode }) => (
    <AssistanceContext.Provider value={{ ...props }}>{children}</AssistanceContext.Provider>
);

export const useAssistanceContext = () => useContext(AssistanceContext);
